// extracted by mini-css-extract-plugin
export var blockedMessage = "_85-3";
export var blockedOverlay = "_85-1";
export var fadeIn = "_85-2";
export var hereLink = "_85-0";
export var slideUp = "_85-4";